import React from 'react';
import { getCachedMediaUrl } from '../../../../lib/utils/utils';

function LowInventoryItemBar({ product }) {
    return (
        <div className="flex items-center border-t border-[#EAEAEA]">
            <div className="flex items-center gap-2 w-[78%] p-[6px_10px_6px_16px]">
                <div className="size-11 rounded-[5.5px] overflow-hidden">
                    <img className='size-full object-cover' src={getCachedMediaUrl(product.productImgUrls[0])} alt={product.productName} />
                </div>

                <h2 className='w-[calc(100%-44px)] whitespace-nowrap overflow-hidden text-ellipsis text-[#121212] font-medium text-[14px] leading-6'>{product.productName}</h2>
            </div>

            <div className="flex flex-col w-[22%] p-[6px_10px_6px_16px]">
                <p className="text-[14px] leading-6 text-[#121212]">{product.productStock}</p>
            </div>
        </div>
    );
}

export default LowInventoryItemBar;
